<template>
  <div class="z-border-red pa-2 mb-2" style="position:relative;">
    <v-btn
      fab
      depressed
      @click="$emit('onDelete')"
      small
      class="extra-small"
      color="primary"
      style="position: absolute; top: 0; right: 0;margin-top: -15px;margin-right: -15px;"
    >
      <i class="fa fa-trash middle"></i>
    </v-btn>

    <v-layout wrap>
      <v-flex xs12 sm1>
        <move-vertical slot="move" :index="index" :max="max" @onMove="onMove"></move-vertical>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-2">
        <input
          type="text"
          :name="'option_' + index"
          :data-vv-name="'option_' + index"
          :data-vv-as="$t('option')"
          v-validate="'required'"
          class="form-control"
          id="optionInput"
          :placeholder="$t('option') +' '+ $t('EX.Size, Color, Weight')"
          v-model="stock[1]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'sku_' + index"
          :data-vv-name="'sku_' + index"
          :data-vv-as="$t('SKU') + ' (Optional)'"
          class="form-control"
          id="skuInput"
          :placeholder="$t('SKU') + ' (Optional)'"
          v-model="stock[5]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'quantity_' + index"
          :data-vv-name="'quantity_' + index"
          :data-vv-as="$t('quantity')"
          v-validate="'required|numeric'"
          maxlength="4"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          id="quantityInput"
          :placeholder="$t('quantity')"
          v-model="stock[2]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'price_'+ index"
          :data-vv-name="'price_' + index"
          :data-vv-as="$t('Price')"
          v-validate="'decimal:2|min_value:1'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          id="priceInput"
          :placeholder="$t('Price') + '(Optional)'"
          v-model="stock[3]"
          @blur="onBlurPrice"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control pa-2">
        <input
          type="text"
          :name="'saleprice_' + index"
          :data-vv-name="'saleprice_' + index"
          :data-vv-as="$t('Sale price')"
          v-validate="'decimal:2|min_value:1|isLessThanOrEqual:'+ stock[3]"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          id="priceInput"
          :placeholder="$t('Sale price')+'(Optional)'"
          v-model="stock[4]"
        />
      </v-flex>
      <v-flex xs12>
        <div
          class="form-control"
          :class="{'has-error': errors.has('option_'+ index) || errors.has('quantity_'+ index) || errors.has('price_'+ index) || errors.has('saleprice_'+ index)}"
        >
          <span
            class="text-error"
            v-show="errors.has('option_'+ index)"
          >{{ errors.first('option_'+ index) }}</span>
          <span
            class="text-error"
            v-show="errors.has('quantity_'+ index)"
          >{{ errors.first('quantity_'+ index) }}</span>
          <span
            class="text-error"
            v-show="errors.has('price_'+ index)"
          >{{ errors.first('price_'+ index) }}</span>
          <span
            class="text-error"
            v-show="errors.has('saleprice_'+ index)"
          >{{$t('Sale Price cannot be more than Normal Price and less than zero')}}</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
export default {
  inject: ['$validator'],
  props: ['value', 'index', 'max'],
  data: function() {
    return {
      // stock: this.value
    }
  },
  components: {
    MoveVertical
  },
  computed: {
    stock() {
      return this.value
    }
  },
  methods: {
    onMove: function(payload) {
      this.$emit('onMove', payload)
    },
    onBlurPrice: function() {
      this.$set(this.stock, 4, this.stock[3])
    }
  },
  watch: {
    // stock: function() {
    //   this.stock = this.value
    // }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ananda/ProductStockItem.vue